export default "__VITE_ASSET__DWfWn6VI__"